import { ReactNode } from 'react'
import { NavLink, Outlet } from 'react-router'

/**
 * Shell для всех экранов Витрины с табами Обзор / Посты / Настройки.
 * Внутри Outlet рендерится текущий таб (через nested-routes).
 *
 * Если переданы children — рендерим их вместо Outlet (например когда ShowcaseRoute
 * показывает ActivationFlow поверх роутинга, без табов).
 */
export function ShowcaseShell({ children, showTabs = true }: { children?: ReactNode; showTabs?: boolean }) {
  return (
    <div className="showcase-shell">
      <header className="sc-header">
        <p className="sc-eyebrow">SEO-публикация</p>
        <h1 className="sc-title">Витрина</h1>
        <p className="sc-sub">
          Посты канала на портале telegraphyx.ru — поисковики находят, читатели переходят в канал. Бесплатно.
        </p>
      </header>

      {showTabs && (
        <nav className="sc-tabs" aria-label="Разделы Витрины">
          <NavLink end to="/showcase" className={({ isActive }) => `sc-tab ${isActive ? 'active' : ''}`}>
            Обзор
          </NavLink>
          <NavLink to="/showcase/posts" className={({ isActive }) => `sc-tab ${isActive ? 'active' : ''}`}>
            Посты
          </NavLink>
          <NavLink to="/showcase/settings" className={({ isActive }) => `sc-tab ${isActive ? 'active' : ''}`}>
            Настройки
          </NavLink>
        </nav>
      )}

      <div className="sc-content">
        {children ?? <Outlet />}
      </div>

      <style>{`
        .showcase-shell {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .sc-header {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .sc-eyebrow {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--tg-blue, #0066ff);
          margin: 0;
        }
        .sc-title {
          font-size: 28px;
          font-weight: 800;
          color: var(--tg-ink, #111);
          margin: 0;
          letter-spacing: -0.02em;
        }
        .sc-sub {
          font-size: 14px;
          color: var(--tg-mute, #5b6678);
          margin: 0;
          max-width: 640px;
          line-height: 1.5;
        }
        .sc-tabs {
          display: flex;
          gap: 4px;
          border-bottom: 1px solid var(--tg-line-2, #f0f0f4);
          padding-bottom: 0;
        }
        .sc-tab {
          padding: 10px 16px;
          font-size: 14px;
          font-weight: 600;
          color: var(--tg-mute, #5b6678);
          text-decoration: none;
          border-bottom: 2px solid transparent;
          margin-bottom: -1px;
          transition: color 150ms;
        }
        .sc-tab:hover { color: var(--tg-ink, #111); }
        .sc-tab.active {
          color: var(--tg-blue-press, #0052cc);
          border-bottom-color: var(--tg-blue, #0066ff);
        }
        .sc-content {
          min-height: 320px;
        }
        @media (max-width: 600px) {
          .sc-title { font-size: 22px; }
          .sc-tab { padding: 10px 12px; font-size: 13px; }
        }
      `}</style>
    </div>
  )
}
